<div cdkTrapFocus cdkTrapFocusAutoCapture class="modal-content">
  @switch (contentType) {
    @case ('string') {
      <div class="box">
        <div [innerHTML]="content"></div>
      </div>
    }
    @case ('template') {
      <ng-container *ngTemplateOutlet="content; context: context"></ng-container>
    }
    @case ('component') {
      <ng-container *ngComponentOutlet="content"></ng-container>
    }
  }
</div>
